var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCkeckSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ckeck_selected",
    "data-name": "ckeck selected",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.23,
    height: 18.23,
    viewBox: "0 0 18.23 18.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1194",
    "data-name": "Ellipse 1194",
    cx: 9.115,
    cy: 9.115,
    r: 9.115,
    transform: "translate(0)",
    fill: "#39be9d",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31162",
    "data-name": "Path 31162",
    d: "M5.987,27.855,2.131,32.346.514,30.833,0,31.382l2.19,2.048,4.367-5.086Z",
    transform: "translate(6.01 -21.589)",
    fill: "#39be9d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCkeckSelected);
export default __webpack_public_path__ + "static/media/ckeckSelected.9239eaa3cfbc35742d8449ededdb0caa.svg";
export { ForwardRef as ReactComponent };